/*
 * @Descripttion:
 * @Author:
 * @Date: 2020-07-09 09:23:46
 * @LastEditors: zuishuanicx 1342142818@qq.com
 * @FilePath: \dzCloud\src\projects\tiktok\store.js
 */

import { ajax } from './../../plugins/axios.js';

const state = {
    brandList: [],
};

const mutations = {
    setBrandList(state, data) {
        state.brandList = data;
    },
};

const getters = {};

const actions = {
    // eslint-disable-next-line no-unused-vars
    setBrandRunAsync({ commit }, { categoryLeafId = 0, categoryId = 0 }) {
        const brandList = [];
        ajax.post('/api/tiktok/Category/BrandList', {
            query: null,
            categoryId: Number(categoryId),
        }).then((res) => {
            if (res.code == 200) {
                for (const i in res.result.authBrandList) {
                    const Obj = res.result.authBrandList[i];

                    brandList.push({
                        id: Obj.brandId,
                        brandNameCN: Obj.nameEn + (Obj.nameEn && Obj.nameCn && '/') + Obj.nameCn,
                    });
                }
                brandList.unshift({
                    id: 596120136,
                    brandNameCN: '不设置',
                });
                commit('setBrandList', brandList);
            } else {
                this.$message.error(res.msg);
            }
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
